import { render, staticRenderFns } from "./StoryPointers.vue?vue&type=template&id=78133bce&scoped=true&"
import script from "./StoryPointers.vue?vue&type=script&lang=ts&"
export * from "./StoryPointers.vue?vue&type=script&lang=ts&"
import style0 from "./StoryPointers.vue?vue&type=style&index=0&id=78133bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78133bce",
  null
  
)

export default component.exports